<template>
  <div class="viper-text-area" :style="{ width: width + 'px' }">
    <form-field-label :required="required">{{ schema.label }}</form-field-label>
    <div class="viper-text-area-value">
      <form-field-value
        v-if="formOptions.readonly"
        :value="model[schema.model]"
        :suffix="suffix"
      ></form-field-value>
      <v-textarea
        v-else
        v-model="model[schema.model]"
        outlined
        single-line
        class="viper-outline-input"
        :required="required"
        :suffix="suffix"
        :error-messages="errorMessages"
        @input="triggerValidation()"
        @blur="triggerValidation()"
      >
      </v-textarea>
    </div>
  </div>
</template>

<script>
import FormFieldMixin from '@/components/form-fields/FormFieldMixin'
import FormFieldLabel from '@/components/form-fields/FormFieldLabel'
import FormFieldValue from '@/components/form-fields/FormFieldValue'

export default {
  components: { FormFieldValue, FormFieldLabel },
  mixins: [FormFieldMixin]
}
</script>
